import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute, CanLoad} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router:Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) {
    
    const expectedRight:string = route.firstChild.firstChild.firstChild.data['expectedRight'];
    if(expectedRight != undefined && this.authService.checkRights(expectedRight) && this.authService.isAuthenticated()){
      return true;
    }else if(expectedRight != undefined && !this.authService.checkRights(expectedRight) || expectedRight != undefined && !this.authService.isAuthenticated()){
      this.router.navigate(['pages/login']);
      return false;
    }else if(expectedRight == undefined){
      return true;
    }
    
  }
}
